import ajax from '@/modules/ajax';

import { loading, trigger } from '@/modules/helper';

export default class Autocomplete {
  constructor(options) {
    this.field = options.field;
    this.options = options;
    this.result = options.result;
    this.resultRemovable = options.resultRemovable;
  }

  afterSelected(json) {
    const html = this.options?.templates?.result(json);

    if (this.result) {
      const field = this.field[0];

      this.result.innerHTML = html;

      if (this.resultRemovable !== false) field.style.display = 'none';

      if (field.readOnly) {
        this.result.querySelector('.complety__list').classList.add('complety__list--readonly');
      } else if (this.resultRemovable !== false) {
        this.result.addEventListener('click', (evt) => {
          field.value = '';
          field.style.display = 'block';

          evt.currentTarget.innerText = '';

          if (this.resultRemovable !== false) field.focus();

          this.field.trigger('hide', json);
        });
      }
    }

    trigger(this.field[0], 'show', json);
  }

  binds() {
    if (this.prevent.indexOf('selected') < 0) {
      this.field.on('complety:selected.autocomplete', this.handleSelected.bind(this));
    }
  }

  create() {
    // The field lives in the page markup, so it survives a re-init and would keep the handlers from
    // the previous one. Only what this class owns is cleared: `.complety` from the plugin and
    // `complety:selected.autocomplete` from `binds`. The `show`/`hide` handlers belong to the
    // callers, which bind them before and after this runs.
    this.field.off('.complety').off('complety:selected.autocomplete');

    this.field.complety(this.options);

    this.complety = this.field.data('complety');

    // We can prevent some events like `selected`
    this.prevent = this.options.prevent || [];

    this.wrappers = this.complety.wrappers();

    this.binds();

    const dataset = this.field[0].dataset;

    // It was trigging the selected event twice, but without it we can't set the read only data
    // When it triggers twice, action like bind refund that depends on the 'show' event will be triggered twice
    // So for read only fields we trigger it manually
    // For fields not read only like invoice form edition, we need the autoload to be true to indicate it
    // TODO: We may use just autoload in the future?
    if (dataset.value && (this.field[0].readOnly || dataset.autoload === 'true')) this.handleSelected();
  }

  fail(json) {
    $.notify({
      body: json.status,
      details: json.responseText,
      title: json.statusText,
    });
  }

  handleSelected() {
    if (this.options.cleanField) this.field.val('');
    if (this.result) this.onSelected();
  }

  onSelected() {
    // data has priority because complety still use it, so those commands are fresher
    const attributes = Object.assign({}, this.field[0].dataset, this.field.data());
    const body = {};
    const params = {};
    const url = this.field.data('selectUri').replace(':id', attributes.value || this.field.val());

    for (let key in attributes) {
      if (/^completyParam.+/.test(key)) {
        const paramName = key.replace('completyParam', '');
        const name = this.underscored(paramName);

        params[name] = attributes[key];
      }
    }

    ajax({
      body,
      done: this.afterSelected.bind(this),
      loading: (bool) => loading(bool),
      params,
      url,
    });
  }

  underscored(text) {
    return text.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
  }
}
